'use es6';

import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { List as ImmutableList } from 'immutable';
import PortalIdParser from 'PortalIdParser';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { trackEvent, EVENTS } from '../../../lib/usageTracker';
import { getViewDashboardNameProblem } from 'dashboard-lib/public/enable-action/view-dashboard-name';
import { USER_DASHBOARD_PERMISSION } from 'dashboard-lib/private/action-problem-solution/params/all-params';
import { useDashboardsMap } from '../../../hooks/useDashboardsMap';
import { getDateString } from '../../../utils/timeUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const hydrateDashboardInfoWithLastViewedAt = (reportDashboardInfo, dashboards) => {
  return reportDashboardInfo.map(dashboardInfo => {
    const lastViewedAt = dashboards === null || dashboards === void 0 ? void 0 : dashboards.getIn([dashboardInfo.get('id'), 'lastViewedAt']);
    return dashboardInfo.set('lastViewedAt', lastViewedAt);
  });
};
const DashboardCountCell = ({
  parentDashboards
}) => {
  const dashboardsMap = useDashboardsMap();
  const hydratedParentDashboards = useMemo(() => hydrateDashboardInfoWithLastViewedAt(parentDashboards, dashboardsMap), [parentDashboards, dashboardsMap]);
  const parentCount = hydratedParentDashboards.size;
  const viewableDashboards = hydratedParentDashboards.filter(dashboard => !getViewDashboardNameProblem({
    [USER_DASHBOARD_PERMISSION]: dashboard.get('userPermissionLevel')
  }));
  const privateDashboardCount = parentCount - viewableDashboards.size;
  return /*#__PURE__*/_jsx("td", {
    children: /*#__PURE__*/_jsx(View, {
      as: "div",
      textAlign: "left",
      children: parentCount === 0 ? parentCount : /*#__PURE__*/_jsx(Tooltip, {
        use: "longform",
        maxInlineSize: "800px",
        headingText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reports.table.row.appearsOn"
        }),
        title: /*#__PURE__*/_jsxs(List, {
          styled: true,
          paddingInlineStart: "500",
          children: [viewableDashboards.map(dashboard => {
            const dashboardId = dashboard.get('id');
            const lastViewedAt = dashboard.get('lastViewedAt');
            return /*#__PURE__*/_jsxs(ListItem, {
              children: [/*#__PURE__*/_jsx(Link, {
                href: `/reports-dashboard/${PortalIdParser.get()}/view/${dashboardId}`,
                onClick: () => {
                  trackEvent(EVENTS.openDashboard);
                },
                children: dashboard.get('name')
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Text, {
                as: "small",
                children: lastViewedAt ? /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "reporting-action-components.actions.delete.modal.table.dashboardLastViewedHelperText",
                  options: {
                    date: getDateString(lastViewedAt)
                  }
                }) : /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "reporting-action-components.actions.delete.modal.table.dashboardNeverViewed"
                })
              })]
            }, `dashboard-${dashboardId}`);
          }), privateDashboardCount > 0 && /*#__PURE__*/_jsx(ListItem, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'reports.permissions.privateDashboards',
              options: {
                count: privateDashboardCount
              }
            })
          })]
        }),
        children: /*#__PURE__*/_jsx(Link, {
          children: parentCount
        })
      })
    })
  });
};
DashboardCountCell.propTypes = {
  parentDashboards: PropTypes.instanceOf(ImmutableList).isRequired
};
export default DashboardCountCell;